<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="确认收货" left-arrow fixed
                     @click-left="back"/>
        <h5>商品信息</h5>
        <van-row v-for="(item,index) in order.detailList">
            <van-row class="pro-bd">
                <van-col span="10">
                    <img :src="item.goodsPic"/>
                </van-col>
                <van-col span="14">
                    <p>{{item.goodsName}}</p>
                    <p><span>商品单位</span>{{item.goodsUnitSeller}}</p>
                    <p><span>出库数量</span>{{item.receivedCount}}</p>
                    <p><span>出库单价</span>{{item.deliveryPrice}}</p>
                </van-col>
            </van-row>
           <!-- <van-row v-if="(order.orderGoodsType==3 || order.orderGoodsType==4)&& item.receivedCount >0">
                <van-field
                        v-model="istruegg[item.id]"
                        readonly
                        label="感官确认"
                        placeholder="请选择"
                        @focus="showPop(item.id)"
                />v-if="item.goods_sign"
            </van-row>-->

            <van-row v-if="item.goodsSign">
                <van-field
                        v-model="shul[item.id]"
                        label="实际到货量"
                        placeholder="请输入实际到货量"
                />
            </van-row>

            <van-row v-if="item.goodsSign">
                <van-field
                        v-model="yuanyin[item.id]"
                        readonly
                        label="超出原因"
                        placeholder="请选择超出原因"
                        @focus="showPops(item.id)"
                />
            </van-row>
        </van-row>

        <van-popup v-model="popShows" position="bottom" :overlay="true">
            <van-picker
                    :columns="column"
                    show-toolbar
                    @cancel="onPickerCancels"
                    @confirm="onPickerConfirms"
                    @change="onPickerChanges"
            />
        </van-popup>

        <van-popup v-model="popShow" position="bottom" :overlay="true">
            <van-picker
                    :columns="columns"
                    show-toolbar
                    @cancel="onPickerCancel"
                    @confirm="onPickerConfirm"
                    @change="onPickerChange"
            />
        </van-popup>

        <div class="btn-hd">
            <!--url="#/user/order/arrival"-->
            <van-button size="large" @click="saveShouhuo">确认收货</van-button>
        </div>

    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Picker, Popup,Dialog} from "vant"

    export default {
        name: "userOrderReceive",
        components: {
            [Dialog.name]: Dialog,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        data() {
            return {
                orderId: this.$route.query.id,
                order: {},
                popShow: false,
                popShows: false,
                column: ['收货量与发运量偏差较大'],
                columns: ['合格', '不合格'],
                istruegg: [],
                yuanyin: [],
                shul: [],
                bsid:0
            };
        },
        mounted: function () {
            let that = this
            that.getGoods()
        },
        methods: {
            showPop(id) {
                this.bsid=id
                this.popShow = true;
            },
            showPops(id) {
                this.bsid=id
                this.popShows = true;
            },
            onPickerCancel() {
                this.popShow = false;
            },onPickerConfirm(values) {
                this.istruegg[this.bsid] = values;
                this.popShow = false;
            },
            onPickerChange(picker, values) {
                picker.setColumnValue(1, values);
            },
            onPickerCancels() {
                this.popShows = false;
            }, onPickerConfirms(values) {
                this.yuanyin[this.bsid] = values;
                this.popShows = false;
            },
            onPickerChanges(picker, values) {
                picker.setColumnValue(1, values);
            },
            getGoods() {
                let that = this
                that.order=JSON.parse(localStorage.getItem("outOrderReceive"))
               /* let that = this
                that.$api.get(
                    that.jumuc.order.orderIsShouHuo,
                    {"orderId": that.orderId},
                    successRes => {
                        that.order = successRes.data
                    }
                )*/
            },
            back() {
                history.back();
            },
            saveShouhuo() {
                Dialog.confirm({
                    title: '确认收货',
                    message: '确定收货？'
                }).then(() => {
                    this.confirmReceive();
                }).catch(() => {
                    // on cancel
                });
            },
            confirmReceive(){
                let that = this
                let json = {"orderId": that.order.order.orderId,'deliveryOrderId':that.order.order.deliveryOrderId}
                for (var i = 0; i < that.order.detailList.length; i++) {
                    /*let ggqr = that.istruegg[that.order.goodsList[i].id];
                    if (ggqr) {
                        if (ggqr == '合格') {
                            ggqr = 1
                        }
                        if (ggqr == '不合格') {
                            ggqr = 0
                        }
                    }
                    json['senseCheck_' + that.order.goodsList[i].id] =ggqr*/
                    json['receiveCount_'+ that.order.detailList[i].id]=that.shul[that.order.detailList[i].id]
                    json['remark_'+ that.order.detailList[i].id]=that.yuanyin[that.order.detailList[i].id]
                }
                that.$api.post(
                    that.jumuc.order.confirmDeliverySave,
                    json,
                    successRes => {
                        if(successRes.success){
                            that.$router.push({"path": "/order/out-order",
                            query:{id: that.order.order.orderId}
                            })
                        }else{
                            that.$toast(successRes.msg);
                        }
                    }
                )
            }
        },
    };
</script>
<style lang="less">
    @bule-thame: #3C6EEB;

    .jump-warphd {
        h5 {
            color: @bule-thame;
            font-size: 16px;
            border-bottom: 1px solid #f7f7f7;
            padding: 10px;
        }
        .pro-bd {
            padding: 10px;
            border-bottom: 1px solid #f7f7f7;
            img {
                width: 95%;
            }
            p {
                font-size: 14px;
                line-height: 28px;
                span {
                    display: inline-block;
                    min-width: 60px;
                    margin-right: 5px;
                }
            }
        }
        .btn-hd {
            padding: 40px 20px;
            border-top: 1px solid #f7f7f7;
            button {
                color: #fff;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
        }
        .van-cell:not(:last-child)::after {
            border: none;
        }
    }
</style>
